import { useMemo } from 'react';

// prettier-ignore
export const useTableData = <T,>(
  data: T[],
  isLoading: boolean | undefined,
  pageSize: number
) => {
  return useMemo(() => {
    if (isLoading) {
      return Array.from({ length: pageSize }).fill({}) as T[];
    }
    return data;
  }, [isLoading, data, pageSize]);
};
